import { gql } from '@apollo/client';

export const GET_TRUSTS_USERS = gql`
  query GetTrustsUsers {
    trustsUsers {
      email
      status
      enabled
      createdDate
    }
  }
`;
